export default [{
  path: '/clientes-administrados',
  name: 'clientes-administrados',
  component: () => import(/* webpackChunkName: "clientes-administrados" */ '@/pages/clientes-administrados/ClientesAdministradosPage.vue'),
  meta: { requiresAuth: true },
}]
